// extracted by mini-css-extract-plugin
export var closed = "_9x-1";
export var resizer = "_9x-0";